export const buildSmartLinkPayload = (formData) => {
  const priceValue = Number(formData.price);

  const paymentConfigType =
    formData.paymentType === "open" ? "open" : "fixed";

  let paymentConfig;

  if (formData.paymentType === "open") {
    paymentConfig = {
      paymentType: "unique",
      currency: formData.currency,
      paymentMethod: [formData.paymentMethod],
      minAmount: Number(formData.minAmount),
      maxAmount: Number(formData.maxAmount),
      defaultAmount: formData.defaultAmount
        ? Number(formData.defaultAmount)
        : undefined,
      taxEnabled: false,
    };
  } else {
    const amountDetails = {
      currency: formData.currency,
      subtotalIva: 0,
      subtotalIva0: priceValue,
      iva: 0,
      ice: 0,
      extraTaxes: {},
    };

    paymentConfig = {
      paymentType: formData.paymentType,
      paymentMethod:
        formData.paymentType === "subscription"
          ? ["subscription"]
          : [formData.paymentMethod],
      amount: amountDetails,
      ...(formData.paymentType === "subscription" && {
        subscriptionOptions: {
          amount: amountDetails,
          periodicity: formData.frequency,
          planName: formData.productName,
          startDate: formData.startDate,
          terms: "Acepto los términos de la suscripción",
        },
      }),
    };
  }

  return {
    merchantName: formData.merchantName,
    paymentConfigType,
    paymentConfig,
    generalConfig: {
      productName: formData.productName,
      description: formData.description || " ",
      productImage: "https://peiix.com/img/Peiix_logotipo_color.png",
      brandLogo: "https://peiix.com/img/Peiix_logotipo_color.png",
//  -- Nuevos campos para tu BD --
      limit: formData.limitType === "1", 
      uses: formData.limitType === "1" ? Number(formData.executionLimit) : 0,
      
      
      executionLimit: formData.limitType === "1" ? Number(formData.executionLimit) : 0,
  // --------------------------------
  
  showTimer: true,
      showTimer: true,
      enabled: true,
      termsAndConditions: "Acepto los términos y condiciones",
      promotionalText: "Promoción Única",
      payButtonText: "Pagar",
    },
    styleAndStructure: {
      structure: "checkout",
      primaryColor: "#00E6B2",
      secondaryColor: "#023366",
    },
    contact: {
      email: formData.email,
      phoneNumber: formData.phoneNumber,
    },
    formConfig: [
      {
        label: "Correo",
        type: "input",
        split: false,
        required: true,
        disabled: false,
        name: "email",
        placeholder: "tu@email.com",
      },
    ],
    urls: ["https://masterapi.peiix.com/Peiix/"],
  };
};
